<template>
  <div class="media-block">
    <popper trigger="clickToOpen" :options="{placement: 'right'}" ref="popover">
      <div class="media-block__image-wrapper" slot="reference">
        <div v-if="val.payload">
          <img v-if="val.type === 'image' && src" :src="src">
          <div v-else class="media-block__video-placeholder">
            <fai class="media-block__video-edit-icon" icon="eye-slash"></fai>
            <div
              class="media-block__video-edit-text"
            >{{ $t('view.flow.blockElements.media.unavailable') }}</div>
          </div>
        </div>
        <div v-else class="media-block__image-placeholder">
          <div>
            <fai class="media-block__image-edit-icon" icon="file-image"></fai>
            <div
              class="media-block__image-edit-text"
            >{{ $t('view.flow.blockElements.media.chooseImage') }}</div>
          </div>
        </div>
      </div>

      <div class="popper media-block__popover">
        <div class="media-block__popover-row">
          <sel
            v-model="newMode"
            class="media__popover-input"
            :label="$t('view.flow.blockElements.media.source')"
          >
            <option value="attachment">{{ $t('view.flow.blockElements.media.attachment') }}</option>
            <option value="url">{{ $t('view.flow.blockElements.media.url') }}</option>
          </sel>
          <sel
            v-model="newType"
            class="media__popover-input"
            :label="$t('view.flow.blockElements.media.type')"
            v-if="newMode === 'url'"
          >
            <option value="image">{{ $t('view.flow.blockElements.media.image') }}</option>
            <option value="video">{{ $t('view.flow.blockElements.media.video') }}</option>
          </sel>
        </div>
        <div class="media-block__popover-row media-block__popover-row--full-width">
          <sel
            v-if="newMode === 'attachment'"
            v-model="newAttachment"
            :label="$t('view.flow.blockElements.media.attachment')"
          >
            <option
              v-for="attachment in $store.state.attachments"
              :key="attachment.id"
              :value="attachment.uuid"
            >{{ attachment.name }}</option>
          </sel>
          <in
            v-if="newMode === 'url'"
            v-model="newUrl"
            :label="$t('view.flow.blockElements.media.url')"
          ></in>
        </div>

        <div class="media-block__popover-buttons">
          <btn
            icon="save"
            class="media-block__popover-button"
            @click="saveChanges"
            small
          >{{ $t('btn.save') }}</btn>
        </div>
      </div>
    </popper>
    <div class="media-block__buttons">
      <message-button
        v-for="(button, n) in val.buttons"
        :key="button.uuid"
        :data="button"
        :n="n"
        @change="buttonChange($event, button.uuid, val.uuid)"
        @delete="buttonChange($event, button.uuid, val.uuid, true)"
      ></message-button>
      <div
        class="media-block__button-add-button"
        @click="addButton()"
        v-if="val.buttons.length < 1"
      >
        <fai icon="plus"></fai>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'blockId'],
  data () {
    return {
      val: null,
      src: null,
      newType: null,
      newMode: null,
      newAttachment: null,
      newUrl: null,
      default: {
        button: {
          text: {},
          action: 'redirect',
          data: {
            target: null
          }
        }
      }
    }
  },
  created () {
    this.val = this.value
    this.newType = this.value.type
    this.newMode = this.value.mode
    this.newAttachment = this.value.payload
    this.newUrl = this.value.payload
    if (this.val.mode === 'attachment' && this.$store.state.attachments[this.val.payload] && this.typeOfAttachment(this.$store.state.attachments[this.val.payload].extension) === 'image') this.src = this.$store.state.attachments[this.val.payload].url
    for (let locale in this.$store.state.flowLocales) {
      this.default.button.text[locale] = 'New button'
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    addButton () {
      const i = this.val.buttons.length
      let el = JSON.parse(JSON.stringify(this.default.button))
      el.uuid = this.uid()
      this.$set(this.val.buttons, i, el)
      this.onInput()
    },

    buttonChange (changed, uuid, stepUuid, del) {
      for (let i in this.val.buttons) {
        if (this.val.buttons[i].uuid !== uuid) continue
        if (!del) this.$set(this.val.buttons, i, changed)
        else this.$delete(this.val.buttons, i)
        this.onInput()
        break
      }
    },

    saveChanges () {
      this.val.mode = this.newMode
      if (this.val.mode === 'attachment') {
        this.val.payload = this.newAttachment
        this.val.type = this.typeOfAttachment(this.$store.state.attachments[this.val.payload].extension)
        this.src = this.$store.state.attachments[this.val.payload].url
      } else if (this.val.mode === 'url') {
        this.val.payload = this.newUrl
        this.val.type = this.newType
        this.src = null
      }
      this.onInput()
      this.$refs.popover.doClose()
    },

    typeOfAttachment (ext) {
      if (['.jpg', '.jpeg', '.png', '.gif'].indexOf(ext) !== -1) return 'image'
      else return 'video'
    }
  }
}
</script>

<style lang="scss">
.media-block {
  @include flowElementShadow();
  width: 270px;
  max-height: 300px;
  background-color: white;
  border-radius: 7px;
  overflow: hidden;

  &__image-wrapper {
    max-width: 100%;
    height: 150px;
    max-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > div > img {
      max-width: 100%;
      max-height: 100%;
    }

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }

  &__image-placeholder,
  &__video-placeholder {
    width: 100%;
    height: 150px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    cursor: pointer;
  }

  &__video-edit-icon {
    font-size: 2em;
  }

  &__image-placeholder {
    transition: background-color 0.2s ease;

    & > div {
      transition: transform 0.2s ease;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
      div {
        transform: scale(1.05);
      }
    }
  }

  &__buttons {
    z-index: 1000;
    background-color: white;
  }

  &__button-add-button {
    @include alignedFlex();
    height: 30px;
    border-top: 1px solid $borderGrey;
    transition: background-color 0.2s ease;
    border-radius: 0 0 7px 7px;
    background-color: white;
    color: $danger;
    font-size: 0.9em;
    cursor: pointer;

    &:hover {
      background-color: $messageHover;
    }
  }

  &__popover-row {
    width: 320px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;

    & > div {
      width: 150px;
      margin: 0 5px;
    }

    &--full-width {
      & > div {
        width: 310px;
      }
    }
  }

  &__popover-buttons {
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  &__popover-button {
    margin-top: 14px;
  }
}
</style>
